export const SET_DIALOGS = "/dialogsPage/SET-DIALOGS",
  ADD_MESSAGE = "/dialogsPage/ADD-MESSAGE";
